export default function BookingPeriodsService($http, API_SERVER, Log) {
    var fn = this;

    fn.get = (id) => {
        const endpoint = `/bookingperiods/${id}?expand=resource`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.get(url).then(function (res) {
            return res.data;
        });
    };

    fn.getEntries = function (id) {
        // if (DummyApi.isEnabled()) {
        //     return $q.resolve(DummyApi.bookingPeriodEntries(id));
        // }

        // Endpoint:/
        const endpoint = `/bookingperiods/${id}/entries`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.get(url).then(function (res) {
            return res.data;
        });
    };

    /**
     *
     * @param {int} id
     * @param {obj} bookingPeriodEntry
     */
    fn.addEntry = function (id, entry) {
        // if (DummyApi.isEnabled()) {
        //     return $q.resolve(DummyApi.bookingPeriodEntries(id));
        // }

        // Endpoint:/
        const endpoint = `/bookingperiods/${id}/entries`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.post(url, entry).then(function (res) {
            return res.data;
        });
    };

    /**
     * PUT
     * https://apiv3.projektbookbyen.dk/index.html#/BookingPeriods/BookingPeriods_UpdateBookingPeriodEntry
     *
     * @param {int} id - bookingPeriodId
     * @param {object} re - resourceEntry
     * @param {int} amount
     */
    fn.updateEntry = (id, bpeId, bpe) => {
        // TO DO ::: LOW ::: Create in DummyApi ???

        // if (DummyApi.isEnabled()) {
        //     const bpe = DummyApi.updateBookingPeriodEntries(id, bpeid);
        //     return $q.resolve(bpe);
        // }

        const reqBody = bpe;

        // Endpoint:
        const endpoint = `/bookingperiods/${id}/entries/${bpeId}`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.put(url, reqBody).then(function (res) {
            return res.data;
        });
    };

    /**
     * https://apiv3.projektbookbyen.dk/index.html#/BookingPeriods/BookingPeriods_CheckPeriod
     * @param {string} start
     * @param {string} end
     * @param {number} resourceId
     * @param {number} bookingId
     */
    fn.checkAvailability = function (start, end, resourceId, bookingId) {
        // Dummy response (not working - needs update)
        // if (DummyApi.isEnabled() && moment(start).year() == "2050") {
        //     if (testKitPeriod.dummyApiObj.available) {
        //         return $q.resolve(DummyApi.checkPeriodSetAvailabilityTo(true));
        //     }
        //     return $q.reject(DummyApi.checkPeriodSetAvailabilityTo(false), 400);
        // }

        // Endpoint:
        const endpoint = "/bookingperiods/check_availability";

        let params = `?start=${start}&end=${end}&resource_id=${resourceId}`;

        // Add bookingID if provided
        if (bookingId) {
            params += `&booking_id=${bookingId}`;
        }

        const url = API_SERVER + endpoint + params;

        Log.endpoint(endpoint, url, "ApiV3");

        return $http.get(url).then(function (res) {
            return res.data;
        });
    };

    /**
     * https://apiv3.bookbyen.dk/index.html#/BookingPeriods/BookingPeriods_CalculatePrice
     * @param {string} start
     * @param {string} end
     * @param {number} resourceId
     * @param {number} activity_id
     * @param {number} user_id
     */
    fn.calculatePrice = function (
        start,
        end,
        resourceId,
        activity_id,
        user_id
    ) {
        // Endpoint:
        const endpoint = "/bookingperiods/calculate_price";

        let params = `?start=${start}&end=${end}&resource_id=${resourceId}`;

        // Add activity_id if provided
        if (activity_id) {
            params += `&activity_id=${activity_id}`;
        }

        // Add user_id if provided
        if (user_id) {
            params += `&user_id=${user_id}`;
        }

        const url = API_SERVER + endpoint + params;

        Log.endpoint(endpoint, url, "ApiV3");

        return $http.get(url).then(function (res) {
            return res.data;
        });
    };

    return fn;
}
